import React, { useState, useEffect } from 'react'
import Item from './Item.js'
import './Products.css'
import { data, dataSync } from './data.js'
import { getProductsByCategory } from '../services/productFeedService'

const Products = (props) => {
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let isMounted = true; // Flag to prevent state updates after component unmounts
    
    const loadProducts = async () => {
      try {
        setLoading(true)
        setError(null)
        
        console.log(`Loading products for category ${props.catId}...`)
        
        // Try to get real products from the feed with timeout
        const products = await Promise.race([
          getProductsByCategory(props.catId),
          new Promise((_, reject) => 
            setTimeout(() => reject(new Error('Timeout')), 15000) // 15 second timeout
          )
        ])
        
        if (isMounted) {
          console.log(`Loaded ${products.length} real products for category ${props.catId}`)
          console.log('Products for category:', products)
          setItems(products)
        }
      } catch (err) {
        console.error('Error loading products:', err)
        
        if (isMounted) {
          setError('Kunde inte ladda produkter från feed')
          
          // Fallback to static data
          const staticProducts = dataSync()
          const categoryProducts = staticProducts.filter(item => item.categoryId === props.catId)
          console.log(`Using ${categoryProducts.length} fallback products for category ${props.catId}`)
          setItems(categoryProducts)
        }
      } finally {
        if (isMounted) {
          setLoading(false)
        }
      }
    }

    loadProducts()
    
    // Cleanup function
    return () => {
      isMounted = false;
    }
  }, [props.catId])

  if (loading) {
    return (
      <div className="prods">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Laddar produkter...</p>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="prods">
        <div className="error-container">
          <p>⚠️ {error}</p>
          <p>Visar tillgängliga produkter...</p>
        </div>
      </div>
    )
  }

  if (items.length === 0) {
    return (
      <div className="prods">
        <div className="no-products">
          <p>Inga produkter hittades i denna kategori.</p>
        </div>
      </div>
    )
  }

  return (
    <div className="prods">
      {items.map((item, i) => (
        <Item
          key={item.productId || i}
          productId={item.productId}
          image={item.image}
          prodName={item.productName}
          price={item.price}
          originalPrice={item.originalPrice}
          brand={item.brand}
          description={item.description}
          inStock={item.inStock}
          rating={item.rating}
          reviews={item.reviews}
          affiliateLink={item.affiliateLink}
        />
      ))}
    </div>
  )
}

export default Products
